import { ContainerGetAllQuery, ContainerStatus, ContainerType } from '../../types';

export const getNotFoundContainers = (
  data: ContainerGetAllQuery,
  containerList: string[] | string,
): ContainerGetAllQuery => {
  if (typeof containerList === 'string' || !containerList) return data;

  containerList = containerList.filter(
    (number) => !data.data.some((container: any) => container.number === number),
  );

  const result = [
    ...data.data,
    ...containerList.map((number) => ({
      number,
      id: '',
      clientYardId: '',
      type: undefined as unknown as ContainerType,
      status: 'NOT_FOUND' as ContainerStatus,
      canTrade: false,
      images: [],
      documents: [],
      clientYard: { client: { code: '', id: '' }, yard: { id: '', address: '', name: '' } },
      gateIn: { driver: { licensePlateNumber: '' }, completedAt: '' },
      gateOut: {
        completedAt: '',
        status: 'ACTIVE' as ContainerGetAllQuery['data'][number]['gateOut']['status'],
      },
      _count: { repair: 0 },
    })),
  ];

  return {
    data: result,
    totalCount: result.length,
  };
};
